import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { GenericEdit } from 'src/app/interfaces/generic-edit';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';




@Component({
    selector: 'app-b2w-attribute',
    templateUrl: './b2w-attribute.component.html',
    styleUrl: './b2w-attribute.component.scss',
    standalone: false
})
export class B2wAttributeComponent  implements OnInit {

  @Output() saving:EventEmitter<boolean> = new EventEmitter();
  attribValidator:AbstractControl[] = [];
  attribs:object[] = [];
  buttonList:ButtonList[] = [];
  product:Object;
  data:GenericEdit = null;
  row:Object = [];
  codeproduct = 100007;
  codecompany = 155;
  codecontract = 28;
  codeproductvar=100007;
  sub1:Subscription;
  sub:Subscription;
  codeskyhub = 1;
  codcategoria = 3381;
  uniqueArray: object[];
  variacao = false;
  table = 'Mktpskyhubspecifications';
  

  constructor(private http:HTTPService, private uid:UserAuthenticationServices,  private spinner:NgxSpinnerService,
    private snackBar:SnackbarService, private cd:ChangeDetectorRef) { }

  ngOnInit(): void {

    if ( this.data != null){  
      this.row = this.data.row;

      this.codecompany = this.data['parentRow']['linha']['CODECOMPANY'];
      this.codeproduct = this.data['parentRow']['linha']['CODEPRODUCT'];
      this.codeproductvar = this.data['parentRow']['linha']['CODEPRODUCTVAR'];
      this.codecontract = this.data['parentRow']['linha']['CODECONTRACT'];
      this.codeskyhub = this.data['parentRow']['linha']['CODESKYHUB'];
      
      if ( this.variacao){
        this.table = 'Mktpskyhubspecificationsvar'
      }
      
    }

    this.buttonList.push({
      color:"primary",
      description:"Salvar",
      action: ()=>{
          this.okFunction();
      }
    },
    {
      color:"warn",
      description:"Cancelar",
      action: ()=>{
          this.cancelFunction();
      }
    })


    this.initialize();
    
  }

  initialize(){
    
    this.spinner.show();

    this.getAttributeData().then((result:Object[])=>{

        
          
          let ob = {
            "entityName":"Mktpb2wcategory",
            "sql":`SELECT CATEGORY
                  FROM MKTPB2WCATEGORY A  
                  WHERE A.CODECOMPANY=${this.codecompany}
                  AND ID=${this.codcategoria}`
          }
          
          this.sub1 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
              
              if( ObjectUtil.isNotEmpty(con['SQL'])){
                this.transformData(con['SQL']);	
              }
              
              if (result.length > 0 ){
                  for ( var attributos of result ){
                      if ( this.variacao){
                        let dataObject = this.attribs.find(x=>x['nameId'] == attributos['KEY_ESPECIFICATION']);
                        
                        if ( dataObject != null ){
                          dataObject['datavalue'] = attributos['VALUE_ESPECIFICATION'];
                        }
                        
                      }else{

                        let dataObject = this.attribs.find(x=>x['nameId'] == attributos['KEY_VALUE']);
                        
                        if ( dataObject != null ){  
                          dataObject['datavalue'] = attributos['VALUE'];
                        }
                      }
                      
                  }
                
              }
              this.cd.detectChanges();
            });
        
      }).catch((error)=>{
        this.spinner.hide();
        throw error;
      }).finally(()=>{  
        this.spinner.hide();
      }
      )
  }

  isRequired(item){
    if ( item.required ==true){
      return true;
    }else{
      return false;
    }
    
  }

  isVariant(item){
    if ( item.toSKU ==true){
      return true;
    }else{
      return false;
    }
    
  }

  deleteItem(item){
      let index = this.attribs.findIndex(i=>i['nameId'] == item.nameId);
      this.attribs.splice(index,1);
  } 

  openDataOption(item){
    throw ("Não implementado");
  }

  
  okFunction(){
    this.salvar(); 
    this.saving.next(true);
  }

  cancelFunction(){
    this.saving.next(false);
  }

  transformData(data){    

    this.attribs = JSON.parse(data[0]['CATEGORY'])['attributes'];    
    this.uniqueArray = Array.from(new Map(this.attribs.map(item => [item['grupId'], item])).values());
  }
  
  prepareData():Object[]{
      let dataObject:Object[] = [];
       
      for ( var data of this.attribs ){
          if ( data['datavalue'] != null && data['datavalue'] != undefined && data['datavalue'] != '' ){
            let ob = {};
          
            if ( this.variacao){
              ob['KEY_ESPECIFICATION'] = data['nameId'];
              ob['VALUE_ESPECIFICATION'] = data['datavalue'];
              ob['CODEPRODUCTVAR'] = this.codeproductvar;
            }else{
              ob['KEY_VALUE'] = data['nameId'];
              ob['VALUE'] = data['datavalue'];
            }
            ob['DESCRIPTION'] = data['name'];
            ob['CODECOMPANY'] = this.codecompany;
            ob['CODECONTRACT'] = this.codecontract;
            ob['CODEPRODUCT'] = this.codeproduct;
            
            ob['CODESKYHUB'] = this.codeskyhub;
            dataObject.push(ob);
          }
      }

      return dataObject;
  }

  salvar(){
    this.spinner.show();
    
    let condicao = `codecompany=${this.codecompany} and codeproduct=${this.codeproduct}`;
    if ( this.variacao ){
      condicao = `codecompany=${this.codecompany} and codeproduct=${this.codeproduct} and codeproductvar = ${this.codeproductvar}`;
    }

    let local = {
      entityName: this.table,
      remove:true,
      removeCondition: condicao,
      data: this.prepareData()
    }

    this.http.post(local,'JsonBrokerServices/save',false,true,true).subscribe(result=>{
        this.snackBar.showSuccess("Atributos importados com sucesso.");
        this.saving.next(true);
        this.spinner.hide(); 
    },(error)=>{
        this.spinner.hide();
        throw error;
    });
  }


  async getAttributeData(){

    return await new Promise((resolve,reject)=>{
      
      let ob = {
        "entityName":this.table,
        "sql":`SELECT B.CODCATEGORIA, A.*
              FROM MKTPSKYHUB B LEFT OUTER JOIN MKTPSKYHUBSPECIFICATIONS A  ON A.CODECOMPANY=B.CODECOMPANY
                                                        AND A.CODEPRODUCT=B.CODEPRODUCT
                                                        AND A.CODECONTRACT=B.CODECONTRACT
                                                        
                                                        
              WHERE B.CODECOMPANY=${this.codecompany}
              AND B.CODEPRODUCT=${this.codeproduct}`
      }

      if ( this.variacao ){
        ob['sql'] = `SELECT B.CODCATEGORIA, A.*
              FROM MKTPSKYHUB B LEFT OUTER JOIN MKTPSKYHUBSPECIFICATIONSVAR A  ON A.CODECOMPANY=B.CODECOMPANY
                                                        AND A.CODEPRODUCT=B.CODEPRODUCT
                                                        AND A.CODECONTRACT=B.CODECONTRACT
                                                        AND A.CODEPRODUCTVAR=${this.codeproductvar}
                                                        
              WHERE B.CODECOMPANY=${this.codecompany}
              AND B.CODEPRODUCT=${this.codeproduct}`
              
              
      }
       
      this.sub1 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
        if ( con['SQL'] ){
          this.codcategoria = con['SQL'][0]['CODCATEGORIA'];

          if ( !ObjectUtil.isNotEmpty(this.codcategoria) ){
            throw Error('Não informado o código da categoria no produto.');
          }
          resolve(con['SQL'] as Object[]);
        }
        
      },(error)=>{
          this.spinner.hide();
          throw error;
          
      });
    })
  }
}
